import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as currentProductsForSomeoneElseState from '../employee-detail.reducer';
import * as currentProductsForSomeoneElseReducer from '../reducers/current-products-for-someone-else.reducer';

export const getCurrentProductsForSomeoneElse = createSelector(
  currentProductsForSomeoneElseState.getCurrentProductsForSomeoneElseState,
  currentProductsForSomeoneElseReducer.getCurrentProductsForSomeoneElseResponse
);
